import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrNotificationComponent } from './pr-notification/pr-notification.component';
import { PrIconModule } from '@app/components/pr-icon/pr-icon.module';
import { PrNotificationHostDirective } from './pr-notification-container/pr-notification-host.directive';
import { PrNotificationContainerComponent } from './pr-notification-container/pr-notification-container.component';

@NgModule({
  imports: [CommonModule, PrIconModule],
  exports: [PrNotificationContainerComponent, PrNotificationHostDirective],
  declarations: [
    PrNotificationComponent,
    PrNotificationContainerComponent,
    PrNotificationHostDirective,
  ],
})
export class PrNotificationModule {}
